import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Play, ChevronLeft } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { api, timeAgo } from "@/lib/api";

export default function ShortsIndex() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/articles", { params: { is_short: true, limit: 60 } })
      .then((r) => setItems(r.data.items || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Header />
      <main className="max-w-[1440px] mx-auto px-4 md:px-8 py-6 md:py-10" data-testid="shorts-index">
        <Link to="/" className="inline-flex items-center gap-1 text-sm font-semibold accent-text hover:underline mb-4">
          <ChevronLeft size={14} /> Volver
        </Link>
        <div className="mb-6 md:mb-8">
          <p className="overline accent-text mb-1">POPU.NEWS</p>
          <h1 className="font-headline uppercase text-3xl md:text-5xl leading-none">
            Shorts <span className="accent-text">·</span> Web Stories
          </h1>
          <p className="text-sm mt-2" style={{ color: "var(--text-muted)" }}>
            Historias verticales · tocá una para empezar
          </p>
        </div>

        {loading ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
            {Array(10).fill(0).map((_, i) => (
              <div key={i} className="aspect-[9/16] rounded-md bg-[color:var(--surface-2)] animate-pulse" />
            ))}
          </div>
        ) : items.length === 0 ? (
          <p className="py-20 text-center text-sm" style={{ color: "var(--text-muted)" }}>
            Aún no hay shorts publicados.
          </p>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
            {items.map((s) => (
              <Link
                key={s.id}
                to={`/shorts/${s.slug}`}
                data-testid={`short-card-${s.slug}`}
                className="group relative aspect-[9/16] rounded-md overflow-hidden border block"
                style={{ borderColor: "var(--border)", background: "#0a0a0a" }}
              >
                {s.featured_image && (
                  <img
                    src={s.featured_image}
                    alt={s.title}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
                <div className="absolute top-2 right-2 w-8 h-8 rounded-full flex items-center justify-center bg-white/10 backdrop-blur-sm border border-white/20">
                  <Play size={14} className="text-white ml-0.5" fill="white" />
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <p className="text-[10px] uppercase tracking-wider font-bold text-white/70">
                    {s.category_slug} · {timeAgo(s.published_at)}
                  </p>
                  <h3 className="font-headline text-white text-sm md:text-base leading-tight line-clamp-3 mt-1">
                    {s.title}
                  </h3>
                </div>
              </Link>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </>
  );
}
